import {Module} from "../index";
import Index from './pages/Index.vue';
import {BankLog} from "@/modules/finances/entity";
import {Bank} from "@/modules/finances/services/Bank";
import messages from "./resources/messages";
import {routes} from "./resources/routes";
import {ActionPointsModule} from "@/modules/action-points";

export class FinancesModule extends Module {
  messages = messages;
  routes = routes;

  public entities = [
    BankLog,
  ];

  protected register() {
    super.register();

    this.app.bind<Bank>(Bank).to(Bank);
  }
}
